// Human-readable "2h ago" / "in 3d" for a timestamp.
//
// Accepts anything `new Date()` takes, because the callers disagree: the
// sessions pages hold epoch ms from S3 metadata, the CLI-token table holds ISO
// strings from Mongo. `empty` is what an absent value renders as — a table cell
// wants an em dash, an inline caption wants nothing at all.
export default (value, { empty = '—' } = {}) => {
  if (!value) { return empty }

  const ms = new Date(value).getTime();
  if (Number.isNaN(ms)) { return empty }

  const diff = ms - Date.now();
  const future = diff > 0;
  const sec = Math.round(Math.abs(diff) / 1000);

  if (sec < 60) { return useT(future ? 'relative.inUnderMin' : 'relative.justNow') }

  const min = Math.round(sec / 60);
  if (min < 60) { return useT(future ? 'relative.inMin' : 'relative.minAgo', { n: min }) }

  const hours = Math.round(min / 60);
  if (hours < 24) { return useT(future ? 'relative.inHour' : 'relative.hourAgo', { n: hours }) }

  const days = Math.round(hours / 24);
  if (days < 30) { return useT(future ? 'relative.inDay' : 'relative.dayAgo', { n: days }) }

  const months = Math.round(days / 30);
  if (months < 12) { return useT(future ? 'relative.inMonth' : 'relative.monthAgo', { n: months }) }

  const years = Math.round(months / 12);
  return useT(future ? 'relative.inYear' : 'relative.yearAgo', { n: years });
};
